import styled from 'styled-components';
import { Layout, Button } from 'antd';

export const FooterLayout = styled(Layout.Footer)`
  background-color: ${({ theme }) => theme.bodyBackground};
  color: ${({ theme }) => theme.textColor};
`;

export const LinkButton = styled(Button)``;
